import React, { useState, useEffect } from 'react';
import { ListItem, ListItemAvatar, ListItemText } from '@mui/material';
import { formatDate } from '../../utils';
import { useMobileDetect } from '../../hooks';
import { AvatarFL } from '../ui/AvatarFL';

export const ChatsMensagem = ({ chat, isMyMessage }) => {
    const isMobile = useMobileDetect();
    const { nomeChat, tipoChat } = chat;

    const bgColor = getBgColorByUser(tipoChat);

    const ChatHeader = () => {
        return (
            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', fontSize: '0.9rem', color: getHeaderTextColor(isMyMessage) }}>
                <span>{nomeChat}</span>
                <span style={{ fontSize: '0.7rem' }}>{formatDate(chat.created_at)}</span>
            </div>
        );
    };

    return (
        <>
            <ListItem
                sx={{
                    display: 'flex',
                    marginBottom: 1,
                    borderRadius: 1,
                    bgcolor: bgColor,
                    overflowY: 'auto',
                    width: isMobile ? '85%' : '75%',
                }}
            >
                {!isMyMessage && (
                    <ListItemAvatar sx={{ margin: 0 }}>
                        <AvatarFL
                            name={nomeChat}
                            width={30}
                            height={30}
                            color="var(--primary-dark-color)"
                            fontSize={14}
                        />
                    </ListItemAvatar>
                )}
                <ListItemText
                    primary={<ChatHeader />}
                    secondary={<span dangerouslySetInnerHTML={{ __html: chat.mensagem }} />}
                />
            </ListItem>
        </>
    );
};

const getHeaderTextColor = (isMyMessage) => {
    return isMyMessage ? 'var(--white-color)' : 'var(--primary-dark-color)';
};

const getBgColorByUser = (chatType) => {
    if (chatType === 1) {
        return 'var(--grey-50-color)';
    } else if (chatType === 2) {
        return 'var(--primary-light-color)';
    } else if (chatType === 3) {
        return 'var(--blue-color)';
    }
};
